module.exports = __webpack_public_path__ + "500-illustration.943dd2007d5e54a55a5067be12c22177.svg";